import axios from 'axios'
import { baseURL } from './config.js'
import qs from 'qs'

export default {

  // 获取各种下拉列表数据
  getSelectCommonList(path, params, method="post") { 
    const url =  baseURL + path;
    return axios[method](url, qs.stringify(params));
  },
  
  
  
}


// WEBPACK FOOTER //
// ./src/api/basic.js